/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferServicesResponse } from '../../models/offer-services-response';

export interface GetOfferServices$Params {
  id: number;
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
}

export function getOfferServices(http: HttpClient, rootUrl: string, params: GetOfferServices$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferServicesResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferServices.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferServicesResponse>;
    })
  );
}

getOfferServices.PATH = '/offers/{id}/services';
